// extracted by mini-css-extract-plugin
module.exports = {"pending-change-request":"PendingChangeRequest_pending-change-request__B4Me4"};